module.exports = __webpack_public_path__ + "europa-5_back.jpg?3bb0469b249e79a4fc6b14159aceebda";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_back.jpg
// module id = 385
// module chunks = 0